import {handleActions} from 'redux-actions';

import {
    USER_SET,
    USER_RESET,
} from './UsersActions';
import {
    UserState,
    UserAction,
    UserPayload,
} from '../UsersTypes';

export const setUser = (state: UserState, action: UserAction): UserState => {
    return action.payload;
};

export const resetUser = (): UserState => {
    return initialState;
};

export const initialState = {
    id: 0,
    email: '',
    name: '',
    roles: [],
    status: '',
    updatedAt: '',
    createdAt: '',
    lastLoginAt: null,
    deletedAt: null,
};
const handlers = {
    [USER_SET]: setUser,
    [USER_RESET]: resetUser,
};

export default handleActions<UserState, UserPayload>(handlers, initialState);
